module.exports = __webpack_public_path__ + "static/slack-ed984809cc11bb3196546bdb0666f74b.png";